import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  timeUpdated =
    "Sun May 31 2020 01:21:00 GMT+1000 (Australian Eastern Standard Time)";

  constructor() {}

  ngOnInit() {}
}
